module.exports = __webpack_public_path__ + "static/img/money.fb5c585.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/commons/money.png
// module id = 9hpj
// module chunks = 1